import {useEffect} from 'react';
import { BrowserRouter, Routes, Route, Navigate  } from 'react-router-dom';
import Main from './pages/Main/Main'
import Form from './pages/Form/Form'
import Planos from './pages/Planos/Planos'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify';
import Floricultura from './pages/Floricultura/Floricultura';
import Livrarias from './pages/Livrarias/Livrarias.jsx';


function App() {
  useEffect( () => {
      
  }, [] );

  const defName = "/";

  return (
    
          <BrowserRouter>
            <ToastContainer autoClose={2000} />
            <Routes>
         
                <Route exact path={defName} element={<Main/>}/>
                <Route exact path={defName+'/form'} element={<Form/>}/>
                <Route exact path={defName+'/registro'} element={<Form/>}/>
                <Route exact path={defName+'/planos'} element={<Planos/>}/>
                <Route exact path={defName+'/floricultura'} element={<Floricultura/>}/>
                <Route exact path={defName+'/livrarias'} element={<Livrarias/>}/>
            </Routes>
          </BrowserRouter>

  );
}

export default App;
